<template>
  <div id="patent">
    <div class="patent_box">
      <div class="patent_class">
        <span class="patent_class_span">分类:</span>
        <el-button @click="select(null)" :class="status === null? 'btn_active' : ''" type="text">全部</el-button>
        <el-button @click="select(1)" :class="status === 1? 'btn_active' : ''" type="text">待融资</el-button>
        <el-button @click="select(2)" :class="status === 2? 'btn_active' : ''" type="text">已融资</el-button>
        <el-button @click="select(3)" :class="status === 3? 'btn_active' : ''" type="text">待交易</el-button>
        <el-button @click="select(4)" :class="status === 4? 'btn_active' : ''" type="text">已交易</el-button>
      </div>
      <div class="patent_class" style="margin-top:10px">
        <span class="patent_class_span">类型:</span>
        <el-button
          @click="change_patent(null)"
          :class="pa_status === null? 'btn_active' : ''"
          type="text"
        >全部</el-button>
        <el-button
          @click="change_patent(1)"
          :class="pa_status === 1? 'btn_active' : ''"
          type="text"
        >国际专利</el-button>
        <el-button
          @click="change_patent(2)"
          :class="pa_status === 2? 'btn_active' : ''"
          type="text"
        >国内专利</el-button>
      </div>
      <div class="patent_list clearfix" v-loading="loading">
        <div class="item" v-for="item in list" :key="item.id">
          <router-link class="item_img" tag="div" :to="'/patent_details?id=' + item.id">
            <img width="100%" height="100%" :src="item.image" alt />
          </router-link>

          <router-link
            class="item_title"
            tag="div"
            :to="'/patent_details?id=' + item.id"
          >{{item.name}}</router-link>
          <div class="item_patent">{{item.type === '1' ? '国际专利' : '国内专利'}}</div>
        </div>
        <div v-if="list.length === 0" style="height:500px;font-size:30px;text-align:center">暂无专利交易</div>
      </div>
      <el-pagination
        background
        layout="total,prev, pager, next"
        :page-size="20"
        :total="total"
        hide-on-single-page
        @current-change="setpage"
        style="text-align:right"
      ></el-pagination>
      <div style="height:50px"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      list: [],
      page: null,
      total: null,
      status: null,
      pa_status: null,
      loading: false
    };
  },
  activated() {
    this.$store.commit("set_top_nav", "9");
  },
  created() {
    this.geting();
  },
  methods: {
    setpage(page) {
      this.page = page;
      this.geting();
    },
    select(e) {
      this.status = e;
      this.page = null;
      this.geting(e);
    },
    change_patent(t) {
      this.page = null;
      this.pa_status = t;
      this.geting();
    },
    geting(e) {
      this.loading = true;
      this.axios
        .get(this.serve + "/patents", {
          params: {
            page: this.page,
            status: e,
            type: this.pa_status
          }
        })
        .then(res => {
          this.loading = false;
          this.list = [];
          this.list = res.data.results;
          this.page = res.data.page;
          this.total = res.data.total;
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#patent {
  width: 100%;
  border-top: 2px solid #e2211c;
  .patent_box {
    width: 1200px;
    margin: 0 auto;
    .patent_class {
      width: 100%;
      background: #fff;
      height: 40px;
      margin-top: 21px;
      .patent_class_span {
        font-size: 14px;
        font-family: "Microsoft YaHei";
        padding-left: 9px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      button {
        margin-left: 40px;
        color: #333333;
      }
      button:hover {
        color: #e2211c;
      }
      .btn_active {
        color: #e2211c;
      }
    }
    .patent_list {
      margin-top: 20px;
      width: 100%;
      padding-bottom: 60px;
      min-height: 500px;
      .item {
        width: 225px;
        height: 320px;
        background: rgba(255, 255, 255, 1);
        float: left;
        margin-bottom: 15px;
        padding-left: 5px;
        margin-right: 10px;

        /* box-sizing: border-box; */
        .item_img {
          width: 200px;
          height: 200px;
          margin: 0 auto;
          padding-top: 15px;
        }
        .item_title {
          height: 48px;
          padding: 0 15px;
          border-bottom: 1px solid #dddddd;
          line-height: 48px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .item_title:hover {
          color: #e2211c;
        }
        .item_patent {
          font-size: 16px;
          font-family: "Source Han Sans CN";
          font-weight: 400;
          color: rgba(226, 33, 28, 1);
          text-align: center;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>